import { z } from 'zod';
export const createContractorSchema = z.object({
    name: z.string().min(1).max(255),
    role: z.string().max(100).optional(),
    phone: z.string().max(20).optional(),
    username: z.string().max(100).optional(),
});
export const updateContractorSchema = createContractorSchema.partial();
export const linkTelegramSchema = z.object({
    tgUserId: z.number(),
    username: z.string().optional(),
});
export const contractorSchema = z.object({
    id: z.string(),
    projectId: z.string(),
    name: z.string(),
    role: z.string().nullable(),
    tgUserId: z.string().nullable(),
    username: z.string().nullable(),
    phone: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
//# sourceMappingURL=contractor.js.map